<section class="login-section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="login-form">
                    <!-- <img src="assets/images/logo.png" width="180" class="img-fluid my-5 pt-md-5"> -->

                    <!-- server error  -->
                    <!-- <div class="alert alert-danger py-4 font-16 text-center text-error">
                        Incorrect Username or password
                    </div> -->
                    <h2 class="font-black  pt-md-4">{{ "ACADEMICA" | translate | titlecase }}</h2>
                    <br/>
                    <h4 class="font-black  pt-md-4">{{ "LOGIN" | translate | titlecase }}</h4>
                    <!-- <p class="font-16 pb-5 pt-4 text-grey">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    </p> -->
                    <form class="row" [formGroup]="loginForm" (change)="loginFormChange()" (submit)="loginFormSubmit()">
                        <div class="form-group col-12">
                            <label class="font-bold">{{ "USER_NAME" | translate | titlecase }} &nbsp;<span style="color:cornflowerblue">*</span></label>
                            <input type="text" class="form-control" formControlName="username">
                        </div>
                        <div class="form-group col-12">
                            <label class="font-bold">{{ "PASSWORD" | translate | titlecase }}&nbsp;<span style="color:cornflowerblue">*</span></label>
                            <input type="password" class="form-control" formControlName="password">
                        </div>
                        <div class="form-group col-12">
                            <button type="submit" class="btn btn-primary btn-block"
                                [class.disabled]="!loginValid">{{ "LOGIN" | translate | titlecase }}</button>
                        </div>
                        <div class="form-group col-12">
                            <p class="text-center">
                                <a href="#">{{ "FORGET_PASSWORD" | translate | titlecase }}</a>
                                - 
                                <a routerLink="/Registration">{{ "REGISTRATION" | translate | titlecase }}</a>
                            </p>
                        </div>
                        <div class="form-group col-12">
                            <label class="font-bold">{{ "LANGUAGE" | translate }}</label>
                            <select class="form-control custom-select" formControlName="lang" (change)="changeLang()">
                                <option value="en" [selected]="true">{{ "EN" | translate | titlecase }}</option>
                                <option value="ar">{{ "AR" | translate | titlecase }}</option>
                            </select>
                        </div>
                    </form>
                </div>

            </div>

            <!-- <div class="col-md-7 bg-login">
                <h4 class="mt-5 pt-md-5 mb-0 font-bold">School Management System</h4>
                <p class="font-16">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry’s standard dummy text.
                </p>
                <img src="assets/images/v-login.svg" class="img-fluid mt-5">
            </div> -->
        </div>
    </div>
</section>